import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import SMainProducts from "../components/products/MainProducts";

const SProductScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <SMainProducts />
      </main>
    </>
  );
};

export default SProductScreen;
